// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"db4d54b2","259":"b9228698","428":"b83bf76a","467":"c91c2e39","548":"9317cd0a","841":"731ab131"}[chunkId] + ".chunk.js";
};